import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "AccountPage",

	metaInfo: { title: "My Account" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Kinnect Account Settings",
				description: "General info and password update",
				icon: "settings",
				to: { name: "accountSettings" }
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex items={this.items}></KPageIndex>
		</FullWidthLayout>;
	}
};
